/**
 * `register` hands back two props meant for the akui controls rather than for the DOM: `focused`,
 * which those controls turn into their own styling, and the arrow-key handler that only the
 * text-like ones (`select`, `autocomplete`) listen to. A plain `<button>` wants neither, and React
 * warns about both - so the styling is read off `focused` and only the rest is spread.
 */
export const domNavProps = <T extends { focused?: boolean }>(props: T) => {
  const {
    focused: _focused,
    $keyboardNavigationChangeFocus: _changeFocus,
    ...rest
  } = props as T & { $keyboardNavigationChangeFocus?: unknown };

  return rest;
};
